var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shop-info-box" }, [
    _vm.hasInfo
      ? _c("div", { staticClass: "shop__content" }, [_vm._t("info-area")], 2)
      : _vm._e(),
    _vm._v(" "),
    _vm.hasCta
      ? _c("div", { staticClass: "shop__cta-area" }, [_vm._t("cta-area")], 2)
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }